import { isEmpty } from 'lodash';
import type { RecordsAnalysisResultsDto } from '../../redux/config/widgetApi';
import { InsightItem } from '../common/insight-item.component';

interface RecordInsightFieldsProps {
  insightItem: RecordsAnalysisResultsDto | undefined;
}

export const RecordInsightFields = ({ insightItem }: RecordInsightFieldsProps) => {
  if (isEmpty(insightItem)) {
    return null;
  }

  const {
    data_analysis = '',
    root_cause = '',
    frequency_trends = '',
    benchmarking = '',
    recommendations = '',
  } = insightItem || {};

  const insightFields = [
    ['Data Analysis', data_analysis],
    ['Root Cause', root_cause],
    ['Frequency Trends', frequency_trends],
    ['Benchmarking', benchmarking],
    ['Recommendations', recommendations],
  ];

  return (
    <>
      {insightFields.map(([label, fieldValue]) => (
        <InsightItem key={label} label={label} value={fieldValue} />
      ))}
    </>
  );
};
